import React from 'react';
import styles from '../../styles.css.js';
import { renderMonthAndYear } from '../utils/intl';
import HeaderButton from './button';
var CalendarHeader = function (_a) {
    var baseDate = _a.baseDate, locale = _a.locale, onChangeMonth = _a.onChangeMonth, previousMonthLabel = _a.previousMonthLabel, nextMonthLabel = _a.nextMonthLabel, calendarHasFocus = _a.calendarHasFocus;
    return (React.createElement("div", { className: styles['calendar-header'] },
        React.createElement(HeaderButton, { ariaLabel: previousMonthLabel, isPrevious: true, onChangeMonth: onChangeMonth, focusable: calendarHasFocus }),
        React.createElement("div", { className: styles['calendar-header-month'], "aria-live": "polite" }, renderMonthAndYear(locale, baseDate)),
        React.createElement(HeaderButton, { ariaLabel: nextMonthLabel, isPrevious: false, onChangeMonth: onChangeMonth, focusable: calendarHasFocus })));
};
export default CalendarHeader;
//# sourceMappingURL=index.js.map